export function checkHasBirdviewMailboxUnread(mailbox) {
  return mailbox.unread > 0
}

export function getBirdviewUnreadEmailsCount(mailboxes) {
  return mailboxes.reduce((sum, mailbox) => sum + mailbox.unread, 0)
}

export function toBirdviewMailboxItem(mailbox) {
  return { id: mailbox.id, title: mailbox.email, unread: mailbox.unread }
}
